import { HammerGestureConfig } from '@angular/platform-browser';
export class MyHammerConfig extends HammerGestureConfig {
    constructor() {
        super(...arguments);
        this.overrides = {
            // Sobreescribe configuración por defecto de HammerJS
            press: { time: 1000 }
        };
    }
}
export class AppModule {
}
